import React, { useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import CertificationToBeSignedDetailsSessions from "pages/certificationToBeSignedDetails/sessions/CertificationToBeSignedDetailsSessions";
import CertificationContext from "module/certification/context/CertificationContext";
import { CertificationInterface } from "module/certification/types";
import routes from "routes/routes";
import CertificationSignContext from "module/certification/sign/CertificationSignContext";

const CertificationToBeSignedDetailsSessionsContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);
  const { sign: signHelper } = useContext(CertificationSignContext);
  const history = useHistory();

  const certification = entity as CertificationInterface;

  const sign = useCallback(async (): Promise<void> => {
    await signHelper();
    history.push(routes.toBeSigned.path);
  }, [history, signHelper]);

  return (
    <CertificationToBeSignedDetailsSessions
      {...{ sessionsIdentifiers: certification.sessions, sign }}
    />
  );
};

export default React.memo(CertificationToBeSignedDetailsSessionsContainer);
